import React, { useContext } from 'react';
import { CircularProgress } from '@mui/material';
import { TextsContext } from '../../context/textsContext';
import { TitleH2Component } from '../TitleH2Component';
import { ParagraphComponent } from '../ParagraphComponent';
import style from '../../scss/saveFavoritePlan.module.scss';

/**
 * Estado "loading" del diálogo de guardar plan favorito: mientras corre el POST/PATCH.
 * El diálogo no muestra acciones ni "X" en este estado (no se puede cerrar).
 *
 * @param {boolean} isEdit  cambia los textos a "actualizar" en modo edición
 */
const SavingState = ({ isEdit = false }) => {
    const { texts } = useContext(TextsContext);

    return (
        <>
            <div className="mb-3 d-flex justify-content-center">
                <CircularProgress size={40} style={{ color: '#002855' }} />
            </div>
            <TitleH2Component styleGroup={`raleway color_primary ${style.title}`}>
                {isEdit
                    ? (texts?.favorite_plan_update_loading_title ?? 'Updating…')
                    : (texts?.favorite_plan_save_loading_title ?? 'Saving…')}
            </TitleH2Component>
            <ParagraphComponent styleGroup={`Poppins ${style.text}`}>
                {isEdit
                    ? (texts?.favorite_plan_update_loading_text ?? 'Please wait while we update your plan.')
                    : (texts?.favorite_plan_save_loading_text ?? 'Please wait while we save your plan.')}
            </ParagraphComponent>
        </>
    );
};

export default SavingState;
